import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation AnswerTemplates($answerTemplate: CreateAnswerTemplateInput!) {
  createAnswerTemplate(answerTemplate: $answerTemplate) {
    id
    text
    value
  }
}
`;

const fieldsName = {
  text: 'T_ANSWER_TEMPLATE_TEXT',
  value: 'T_ANSWER_TEMPLATE_VALUE',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function createAnswerTemplate({ text, value, markerIds }) {
  return apollo.client.mutate({
    mutation,
    variables: {
      answerTemplate: { text, value, markerIds: markerIds.map((item) => parseInt(item, 10)) },
    },
  }).then((data) => data.data.createAnswerTemplate)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default createAnswerTemplate;
